import script from "./QuestionOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionOverview.vue?vue&type=script&setup=true&lang=js"

import "./QuestionOverview.vue?vue&type=style&index=0&id=e11488fa&lang=less"

const __exports__ = script;

export default __exports__